var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item" }, [
    _vm.ticket.bets.length > 1
      ? _c(
          "div",
          {
            staticClass: "header",
            on: { mouseover: _vm.showRebet, mouseleave: _vm.hideRebet },
          },
          [
            _c("div", { staticClass: "ticket-status" }, [
              _c(
                "div",
                {
                  staticClass: "value",
                  class: "status-" + _vm.ticket.status.value.toLowerCase(),
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.ticket.status.name.toUpperCase()) + " "
                  ),
                ]
              ),
            ]),
            _vm.ticket.status.value === "PAYEDOUT"
              ? _c("div", { staticClass: "payout" }, [
                  _c(
                    "div",
                    {
                      staticClass: "value",
                      class: "status-" + _vm.ticket.status.value.toLowerCase(),
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(": ") +
                          " " +
                          _vm._s(_vm.ticket.payout.toFixed(2)) +
                          " "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.rebetVisible || _vm.isMob) &&
                      _vm.ticket.bets.length > 1,
                    expression:
                      "(rebetVisible || isMob) && ticket.bets.length > 1",
                  },
                ],
                staticClass: "rebet",
                on: { click: _vm.rebet },
              },
              [
                _c("span", [
                  _vm._v(
                    " " + _vm._s(_vm._f("translate")("general_rebet")) + " "
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "body" },
      _vm._l(_vm.ticket.bets, function (betItem, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "bet-item",
            class: { rebetMode: _vm.rebetVisible },
            on: {
              mouseover: _vm.showRebet,
              mouseleave: _vm.hideRebet,
              click: function ($event) {
                return _vm.ticketDetails(_vm.ticket)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "bet-value" },
              [
                _vm.ticket.bets.length > 1
                  ? _c(
                      "div",
                      {
                        staticClass: "label status",
                        class: "status-" + betItem.status.value.toLowerCase(),
                      },
                      [
                        _vm._v(
                          " " + _vm._s(betItem.status.name.toUpperCase()) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.ticket.bets.length === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "label status",
                        class:
                          "status-" + _vm.ticket.status.value.toLowerCase(),
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.ticket.status.name.toUpperCase()) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "label subtitle" }, [
                  _c("span", { staticClass: "normal" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("general_round")
                          )
                        ) +
                        _vm._s(": ") +
                        " "
                    ),
                  ]),
                  _c("span", { staticClass: "bolded" }, [
                    _vm._v(" " + _vm._s(betItem.eventId) + " "),
                  ]),
                  _vm._v(" | "),
                  _c("span", { staticClass: "normal" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("translate")(betItem.typeValue)) + " "
                    ),
                  ]),
                  _c("span", { staticClass: "normal" }, [
                    _vm._v(" " + _vm._s(betItem.ballPositions) + " "),
                  ]),
                ]),
                _vm._l(
                  _vm.formatOutcome(betItem.outcome.title),
                  function (value, key) {
                    return _c(
                      "div",
                      {
                        key: key,
                        staticClass: "label title",
                        class: {
                          active: _vm.isBallDrawn(
                            _vm.ticket.product,
                            betItem,
                            value
                          ),
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm._f("translate")(value)) + " ")]
                    )
                  }
                ),
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.rebetVisible || _vm.isMob) &&
                      _vm.ticket.bets.length === 1,
                    expression:
                      "(rebetVisible || isMob) && ticket.bets.length === 1",
                  },
                ],
                staticClass: "rebet",
                on: { click: _vm.rebet },
              },
              [
                _c("span", [
                  _vm._v(
                    " " + _vm._s(_vm._f("translate")("general_rebet")) + " "
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _vm.ticket.superBonus
      ? _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "super-bonus" }, [
            _c("span", { staticClass: "label" }, [
              _c("i", { staticClass: "icon icon-ajs" }),
              _vm._v(
                " " +
                  _vm._s(_vm.ticket.superBonus.name) +
                  " " +
                  _vm._s(" +" + _vm.ticket.superBonus.amount.toFixed(2)) +
                  " "
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }